
export const PLACE_OF_ORIGIN_VOID = {
    town: -1,
    province: -1,
    afip: -1,
};